/**
 * Formats an msisdn passed in in the E164 format (e.g. 32474123456) for display reasons (e.g. 0474 12 34 56)
 */
import { getLogger } from '../../logging';
import { spellOut } from '../accessibility';
import { withNonBreakingSpaces } from '../string';

/**
 * Format a phone number. Also accepts landline numbers.
 *
 * @deprecated Use `formatMsisdn` from `@mv/subscription/util-msisdn`.
 */
export function formatMsisdn(
	msisdn: string | undefined,
	spellOutIntent: 'spell-out' | 'no-spell-out' = 'spell-out',
): string {
	const modifiers = [withNonBreakingSpaces];
	if (spellOutIntent === 'spell-out') {
		modifiers.push(spellOut);
	}
	function withModifiers(input: string) {
		let modified = input;
		for (const modifier of modifiers) modified = modifier(modified);
		return modified;
	}

	const BE_FORMATS = [
		/^32([2349])(\d{3})(\d{2})(\d{2})$/, // fixed, short-form zones (e.g. 02 123 45 67)
		/^32([15678]\d)(\d{2})(\d{2})(\d{2})$/, // fixed, long-form zones (e.g. 012 23 45 67)
		/^32(4\d{2})(\d{2})(\d{2})(\d{2})$/, // mobile (e.g. 0471 23 45 67)
	];

	const COMMON_NUMBERS = [{ key: /^4884(\d\d)?$/, label: 'De Lijn' }];

	if (!msisdn || !msisdn.length) return '';
	if (!/^\d+$/.exec(msisdn)) {
		getLogger('formatMsisdn').warning(`Unexpected input for formatMsisdn: ${msisdn}`);
		return '';
	}

	for (const common of COMMON_NUMBERS) {
		if (common.key.exec(msisdn)) return common.label;
	}

	// ignore shortcodes
	if (msisdn.length <= 4) return withModifiers(msisdn);

	for (const format of BE_FORMATS) {
		const match = format.exec(msisdn);
		if (match) return withModifiers(`0${match[1]} ${match[2]} ${match[3]} ${match[4]}`);
	}

	return withModifiers(`+${msisdn}`);
}
